import React, { useState, useEffect } from 'react';
import './EditVendorModal.css';
import { Vendor } from '../../types/vendor';

interface EditVendorModalProps {
  vendor: Vendor;
  onClose: () => void;
  onSave: (updatedVendor: Partial<Vendor>) => void; // We pass only updated fields
  isSaving: boolean;
}

const EditVendorModal: React.FC<EditVendorModalProps> = ({ vendor, onClose, onSave, isSaving }) => {
  const [formData, setFormData] = useState<Partial<Vendor>>({
    name: '',
    email: '',
    phone: '',
    address: '',
    description: '',
  });

  // Pre-fill the form when the modal opens
  useEffect(() => {
    if (vendor) {
      setFormData({
        name: vendor.name,
        email: vendor.email,
        phone: vendor.phone,
        address: vendor.address,
        description: vendor.description,
        isActive: vendor.isActive,
      });
    }
  }, [vendor]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleStatusChange = (isActive: boolean) => {
    setFormData(prev => ({ ...prev, isActive }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Edit Vendor</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Vendor Name</label>
            <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label htmlFor="address">Address</label>
            <textarea id="address" name="address" value={formData.address} onChange={handleChange} rows={3}></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea id="description" name="description" value={formData.description} onChange={handleChange} rows={3}></textarea>
          </div>
          <div className="form-group">
            <label>Status</label>
            <div className="status-toggle">
                <button type="button" className={formData.isActive ? 'active' : ''} onClick={() => handleStatusChange(true)}>Active</button>
                <button type="button" className={!formData.isActive ? 'active' : ''} onClick={() => handleStatusChange(false)}>Inactive</button>
            </div>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose} disabled={isSaving}>Cancel</button>
            <button type="submit" className="btn-save" disabled={isSaving}>
              {isSaving ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditVendorModal;